import { Head } from '@squareup/dex-ui';
import { DocsPageContentLayout } from '@squareup/dex-ui-dex-tech-docs-page-layout';
import { Box } from '@squareup/dex-ui-shared-base';
import { DocsFloatingToc } from '@squareup/dex-ui-shared-table-of-contents';
import { getNextPublicDocsNameOrDefault } from '@squareup/dex-utils-environment';
import { MDXRemote, MDXRemoteSerializeResult } from 'next-mdx-remote';
import React, { FC, useRef } from 'react';

import { getMdxComponentMap } from './mdx-component-map';

interface MdxPageMetadata {
  title: string;
  browserTitle?: string;
  slug: string;
  eyebrow?: string;
  summary?: string;
  releaseStatus?: string;
}

interface MdxPageContentProps {
  mdxSource: MDXRemoteSerializeResult;
  metadata: MdxPageMetadata;
}

const MdxPageContent: FC<MdxPageContentProps> = ({ mdxSource, metadata }) => {
  const contentRef = useRef<HTMLElement>(null);
  const components = getMdxComponentMap();

  return (
    <DocsPageContentLayout
      gridType="ftoc"
      rightSidebar={
        <DocsFloatingToc
          headerTitle="On this page"
          sections={[]}
          mainContentRef={contentRef}
        />
      }
    >
      <>
        <Head
          title={
            metadata.browserTitle ||
            metadata.title ||
            getNextPublicDocsNameOrDefault()
          }
          description={metadata.summary || ''}
          canonicalPath={`/docs/${metadata.slug}`}
        />
        {metadata.eyebrow && (
          <Box margin={{ bottom: '1x' }}>
            <span>{metadata.eyebrow}</span>
          </Box>
        )}
        <Box ref={contentRef}>
          <MDXRemote {...mdxSource} components={components} />
        </Box>
      </>
    </DocsPageContentLayout>
  );
};

MdxPageContent.displayName = 'MdxPageContent';

export { MdxPageContent };
export type { MdxPageMetadata, MdxPageContentProps };
